import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-stone-950 text-stone-50 py-24 px-4 border-t border-stone-800" data-id="element-99">
      <div className="max-w-4xl mx-auto" data-id="element-100">
        <FadeIn data-id="element-101">
          <h2 className="text-3xl md:text-4xl font-black mb-12 text-center text-amber-500" data-id="element-102">
            El problema no es que estés viejo.
          </h2>

          <div className="bg-stone-900 p-8 md:p-12 rounded-2xl border border-stone-800 shadow-2xl" data-id="element-103">
            <p className="text-xl md:text-2xl leading-relaxed text-stone-300 mb-8" data-id="element-104">
              El problema es que tus articulaciones están operando{' '}
              <strong className="text-stone-50" data-id="element-105">"en seco"</strong>. Durante la
              noche, el lubricante natural de tu cuerpo se vuelve espeso como
              miel fría. Cuando saltas de la cama directamente al suelo, causas
              una fricción que inflama tus tejidos y desgasta tu cartílago.
            </p>

            <div className="flex items-start gap-4 bg-red-950/30 p-6 rounded-xl border border-red-900/50" data-id="element-106">
              <AlertTriangle className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-107" />
              <p className="text-lg md:text-xl text-stone-300" data-id="element-108">
                Si sigues ignorando esta rigidez, el destino es inevitable:
                cirugías costosas, bastones antes de tiempo y la tristeza de no
                poder cargar a tus nietos o jugar un partido de fútbol el fin de
                semana.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}